import { BehaviorSubject } from 'rxjs';

export interface PendingActions {
  changePassword: boolean;
}

class UserPendingActionsStore {
  private static instance: UserPendingActionsStore;

  private pendingActionsSubject: BehaviorSubject<PendingActions>;

  constructor() {
    this.pendingActionsSubject = new BehaviorSubject<PendingActions>({
      changePassword: false,
    });
  }

  public getCurrent() {
    return this.pendingActionsSubject.getValue();
  }

  public getObservable() {
    return this.pendingActionsSubject.asObservable();
  }

  public set(pending: PendingActions) {
    this.pendingActionsSubject.next(pending);
  }

  public static getInstance(): UserPendingActionsStore {
    if (!UserPendingActionsStore.instance) {
      UserPendingActionsStore.instance = new UserPendingActionsStore();
    }
    return UserPendingActionsStore.instance;
  }
}

// Export a singleton instance
const instance = UserPendingActionsStore.getInstance();
Object.freeze(instance);
export default instance;
